import React, { useContext } from 'react'

import { LanguageContext } from '../../utils/LanguageContext'
import * as ShopItemAttributesListStyles from "./shopItemAttributesList.module.css"
import getItemAttributesFromPrismicItem from '../../utils/getItemAttributesFromPrismicItem'

const ShopItemAttributesList = ({ item }) => {
  const { language } = useContext(LanguageContext)

  const itemAttributes = getItemAttributesFromPrismicItem(item, language)
  const attributesListItems = itemAttributes.map((attr, i) => (
    // ? order won't change but the title of the attribute will change on language toggle
    <li key={`attr-${i}`} className={ShopItemAttributesListStyles.listItem}>
      <h3 className={ShopItemAttributesListStyles.title}>{attr.title}</h3>
      {!!attr.value.html
        // * Check for details field of type RichText
        ? <p dangerouslySetInnerHTML={{ __html: attr.value.html }}></p>
        : <p>{attr.value}</p>
      }
    </li>
  ))

  return (
    <ul className={ShopItemAttributesListStyles.list}>
      {attributesListItems}
    </ul>
  )
}

export default ShopItemAttributesList
